import React from 'react';
import { useTranslation } from 'react-i18next';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { ExtendedInfoStateIndicator, ExtendedInfoSVG } from '../ExtendedInfo';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Icons } from '../../../components/atoms/SVG';
import { Namespace } from '../../../translation/namespace';
import { ISonURL } from '../../../types/IUrl';
import { TextMarker } from '../TextMarker/TextMarker';

type PageLinkExtendedInfo = {
  pageLink: ISonURL;
  stateIndicatorStatus?: 'red';
  stateIndicatorHelpText?: string;
  restricted?: boolean;

  /** highlight name with <Textmarker> */
  highlightText?: boolean;
};

/**
 * Component generates a link to a SON page with additional infos like pack state and restriction.
 * */
export function PageLinkExtendedInfo({
  pageLink,
  stateIndicatorStatus,
  stateIndicatorHelpText,
  restricted,
  highlightText,
}: PageLinkExtendedInfo) {
  const { t } = useTranslation(Namespace.glossary);

  return (
    <span className="page-link-extended-info">
      {stateIndicatorStatus && (
        <span className="page-link-extended-info__info-left">
          <ExtendedInfoStateIndicator
            helpText={stateIndicatorHelpText}
            tooltipPlacement={TooltipPlacement.TOP}
            stateIndicatorStatus={stateIndicatorStatus}
          />
        </span>
      )}
      <Hyperlink to={pageLink?.url} className="page-link-extended-info__link">
        {highlightText ? <TextMarker text={pageLink?.name} /> : pageLink?.name}
      </Hyperlink>
      {restricted && (
        <span className="page-link-extended-info__info-right">
          <ExtendedInfoSVG
            helpText={t('restricted')}
            tooltipPlacement={TooltipPlacement.TOP}
            svgSpriteID={Icons.CLOSED_LOCK}
          />
        </span>
      )}
    </span>
  );
}
